import {DataGridPro} from '@mui/x-data-grid-pro'
import ExcelDownLoadModal from 'pages/common/ExcelDownloadModal'
import {customerCheckReportColumns} from 'pages/customer/dataConfig/declearColumns'
import {customerCheckReportFilter} from 'pages/customer/dataConfig/declearFilters'
import {customerCheckReportRows} from 'pages/customer/dataConfig/declearRows'
import {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {ToastContainer} from 'react-toastify'
import {checkValueUpdate, getCheckReportList} from 'utils/apiCalling/api'
import {failAlert} from 'utils/CustomAlert/Alert'
import CustomPagination from 'utils/designSytem/CustomPagination'
import MeterariumPageLayout from 'utils/designSytem/MeterariumPageLayout'
import {scrollTop} from 'utils/func/justUtils'
import {toolTipText} from 'utils/toolTips/toolTipText'

const CustomerCheckReport = (props: any) => {
  /*********************************************************************
   * 1. Init Libs
   *********************************************************************/
  const officeInfo = useSelector((state: any) => state.officeInfo)
  const cooperInfo = useSelector((state: any) => state.cooperInfo)
  const userInfo = useSelector((state: any) => state.userInfo?.userInfo)
  /*********************************************************************
   * 2. State settings
   *********************************************************************/
  const [checkReportList, setCheckReportList] = useState<any>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const [totalCount, setTotalCount] = useState<any>(null)
  const [filter, setFilter] = useState<any>(customerCheckReportFilter)
  const [accordionOpen, setAccordionOpen] = useState<boolean>(false)
  const [downloadOpen, setDownloadOpen] = useState<boolean>(false)
  const [shouldCallApi, setShouldCallApi] = useState<boolean>(false)
  const [updateValue, setUpdateValue] = useState<any>({
    startImei: null,
    startIdxDate: null,
    startValue: null,
    imei: null,
    idxDate: null,
    value: null,
    updateId: userInfo?.userId,
  })
  /*********************************************************************
   * 3. Handlers
   *********************************************************************/

  const getCheckReportListCall = async () => {
    const checkBusan = String(officeInfo.value).slice(0, 2) === '13'
    const hasAnyTrue = Object.values(filter.searchOption).some((v) => v === true)
    const newSearchOption =
      !filter.searchOption.customerNumber && hasAnyTrue
        ? {installer: false}
        : {customerNumber: true}
    let selectedFilter = filter
    if (checkBusan) {
      selectedFilter = {
        ...filter,
        searchOption: newSearchOption,
        // searchOption: {
        //   customerNumber:
        //     !filter.searchOption.customerNumber && !filter.searchOption.managerName
        //       ? true
        //       : filter.searchOption.customerNumber,
        //   managerName:
        //     !filter.searchOption.customerNumber && !filter.searchOption.managerName
        //       ? true
        //       : filter.searchOption.managerName,
        // },
      }
    }

    await getCheckReportList(officeInfo, cooperInfo, selectedFilter, {
      success: (res: any) => {
        setCheckReportList(res)
      },
      count: (count: any) => {
        setTotalCount(count)
      },
      fail: (err: any) => {
        failAlert()
      },
      loading: (loading: boolean) => {
        setLoading(loading)
      },
    })
  }

  const busanSearchHandler = (officeId: any) => {
    const checkBusan = String(officeId).slice(0, 2) === '13'
    // if (checkBusan) {
    //   return ['customerNumber', 'managerName']
    // } else {
    return ['customerNumber', 'customerName', 'address', 'meterDiameter', 'managerName']
    // }
  }

  const checkValueUpdateCall = async () => {
    await checkValueUpdate(updateValue, {
      success: (res: any) => {
        if (res.resultCode === 0) {
          getCheckReportListCall()
          setUpdateValue({
            startImei: null,
            startIdxDate: null,
            startValue: null,
            imei: null,
            idxDate: null,
            value: null,
            updateId: userInfo?.userId,
          })
        }
      },
      fail: (err: any) => {
        failAlert()
      },
      loading: (loading: boolean) => {
        setLoading(loading)
      },
    })
  }
  const rows = customerCheckReportRows(checkReportList)
  const columns: any = customerCheckReportColumns(
    checkReportList,
    updateValue,
    setUpdateValue,
    checkValueUpdateCall,
    setCheckReportList
  )
  const getRowHeightOnDataGrid = (params: any) => {
    // recognizedType 이 각 이미지로 구분되서 여기는 switch문 패스
    const start = params?.model?.startRecognizedType
    const end = params?.model?.endRecognizedType

    if (start === 'PRV' || end === 'PRV') {
      return 260
    }

    return 150
  }
  const searchHandler = () => {
    setFilter((prev: any) => ({...prev, page: 1}))
    setShouldCallApi(true)
  }
  /*********************************************************************
   * 4. UseEffect
   *********************************************************************/
  useEffect(() => {
    if (shouldCallApi) {
      getCheckReportListCall()
      setShouldCallApi(false)
    }
  }, [filter, shouldCallApi])

  useEffect(() => {
    scrollTop()
    getCheckReportListCall()
  }, [filter.date, officeInfo, cooperInfo, filter.page, filter.rowPerPage])
  /*********************************************************************
   * 5. Page configuration
   *********************************************************************/
  return (
    <>
      <MeterariumPageLayout
        headerDescription={toolTipText.customerCheckReport.description}
        tooltipText={toolTipText.customerCheckReport.text}
        hideSearchOptions={accordionOpen}
        setHideSearchOptions={setAccordionOpen}
        filter={filter}
        id={'customer-checkReport'}
        setFilter={setFilter}
        searchCallback={searchHandler}
        total={totalCount}
        control={['selectMonth']}
        actions={['download']}
        searchOptions={busanSearchHandler(officeInfo.value)}
        checkData={null}
        onDelete={null}
        onCancel={null}
        setTypeName={null}
        onDownloadOpen={() => setDownloadOpen(true)}
      >
        <DataGridPro
          rowHeight={150}
          getRowHeight={(params: any) => getRowHeightOnDataGrid(params)}
          headerHeight={30}
          experimentalFeatures={{columnGrouping: true}}
          rows={rows}
          columns={columns}
          rowCount={rows?.length}
          disableColumnMenu
          loading={loading}
          paginationMode={'server'}
          hideFooterPagination={true}
          pagination={true}
          hideFooter={true}
          autoHeight={true}
        />
        <CustomPagination filter={filter} setFilter={setFilter} totalCount={totalCount} />
      </MeterariumPageLayout>
      <ToastContainer />

      <ExcelDownLoadModal
        type={'검침 리포트'}
        search={filter}
        open={downloadOpen}
        onClose={() => setDownloadOpen(false)}
      />
    </>
  )
}
export default CustomerCheckReport
